import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.bl{gap:8px;}.ssr-plugin'
import '.j{gap:16px;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.hk{padding:6px 8px;}.ssr-plugin'
import '.z{flex:1;}.ssr-plugin'
import '.hl{max-width:calc(50% - 52px);}.ssr-plugin'
import { useState, useRef, useEffect } from 'react'
import { styled } from 'inlines'
import { TextInput } from '../../TextInput/index.js'
import { Text } from '../../Text/index.js'
import { radius } from '../../../utils/radius.js'
import { colors } from '../../../tokens/colors.js'
import { IconButton } from '../../IconButton/index.js'
import { Menu } from '../../Menu/index.js'
import { TextAreaInput } from '../../TextAreaInput/index.js'
import { RichTextEditor } from '../../RichTextEditor/index.js'
import { useToast } from '../../Toast/index.js'

type TranslationFieldProps = {
  label?: string
  // onChange?: (value: string) => void
  // value
  // fieldtype
  fieldType?: 'text' | 'textarea' | 'richtext'
  fromValue: string
  toValue?: string
  onTextChange: (data: string) => void
  onStatusChange: (approved: boolean) => void
  approved?: boolean
  to: string
  from: string
}

export const TranslationField = ({
  label,
  fieldType = 'text',
  fromValue,
  toValue,
  onStatusChange,
  onTextChange,
  approved,
}: TranslationFieldProps) => {
  const [text, setText] = useState(toValue)

  const change = (v: string) => {
    setText(v)
    onTextChange(v)
  }

  useEffect(() => {
    setText(toValue)
  }, [toValue, fromValue])

  const ref = useRef<HTMLDivElement>()
  const [fieldHeight, setFieldHeight] = useState(37)

  useEffect(() => {
    if (ref?.current?.clientHeight) {
      setFieldHeight(Math.max(ref?.current?.clientHeight, 37))
    }
  }, [ref.current?.clientHeight])

  const toast = useToast()

  return (
    <div className="a i bl">
      <Text variant="subtext-regular" color="neutral60">
        {label}
      </Text>
      <div className="a j b">
        {fieldType === 'richtext' ? (
          <div
            style={{
              maxWidth: 'calc(50% - 52px)',
              width: '100%',
              flex: 1,
              marginRight: -16,
            }}
          >
            <RichTextEditor
              onChange={() => {}}
              value={fromValue}
              disabled
              style={{
                background: 'transparent',
                border: `1px solid ${colors.neutral20Adjusted}`,
                color: colors.neutral60,
                height: fieldHeight,
              }}
            />
          </div>
        ) : (
          <div className="hk a z"
            style={{
              borderRadius: radius[8],
              border: `1px solid ${colors.neutral20Adjusted}`,
              height: fieldHeight,
              alignItems: fieldType === 'text' ? 'center' : 'start',}}
          >
            <Text
              variant="display-regular"
              color="neutral60"
              style={{ overflow: 'auto', width: '100%' }}
            >
              {fromValue}
            </Text>
          </div>
        )}

        <div className="z hl" ref={ref}>
          {fieldType === 'textarea' ? (
            <TextAreaInput disabled={approved} value={text} onChange={change} />
          ) : fieldType === 'richtext' ? (
            <div style={{ marginLeft: 16 }}>
              <RichTextEditor
                value={text}
                onChange={change}
                disabled={approved}
                style={{
                  height: 'auto',
                }}
              />
            </div>
          ) : fieldType === 'text' ? (
            <TextInput disabled={approved} value={text} onChange={change} />
          ) : null}
        </div>

        <styled.div
          style={{
            '& svg': {
              color: approved ? colors.green80 : 'inherit',
            },
          }}
        >
          <IconButton
            onClick={() => {
              if (approved && text) {
                onStatusChange(false)
              } else if (text) {
                onStatusChange(true)
              } else {
                return
              }
            }}
            disabled={!text}
            icon={
              approved && text
                ? 'checkmark-filled'
                : text
                  ? 'circle-regular'
                  : 'circle-dotted'
            }
          />
        </styled.div>

        <Menu>
          <Menu.Trigger>
            <IconButton icon="more-horizontal" />
          </Menu.Trigger>
          <Menu.Items>
            {/* <Menu.Item
              onClick={() => {
                console.log('clicked 🐸')
              }}
              leadIcon="copy"
            >
              Copy lang (original)
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                if (textValue) {
                  navigator.clipboard.writeText(textValue)
                  toast('Copied to clipboard', {
                    icon: 'copy',
                  })
                }
              }}
              leadIcon="copy"
            >
              Copy newlang
            </Menu.Item>
            <Menu.Separator /> */}
            <Menu.Item
              leadIcon="delete"
              color="red"
              onClick={() => {
                change('')
                onStatusChange(false)
              }}
            >
              Clear field
            </Menu.Item>
          </Menu.Items>
        </Menu>
      </div>
    </div>
  )
}
